import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "payment-methods-settings" }
const _hoisted_2 = {
  key: 0,
  class: "payment-methods-settings__method-list-stub"
}
const _hoisted_3 = {
  key: 1,
  class: "payment-methods-settings__method-list"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_PaymentMethodItem = _resolveComponent("PaymentMethodItem")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.associatedPaymentMethodList.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_text, { type: "info" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" No payment methods added yet ", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.associatedPaymentMethodList, (associatedPaymentMethod, index) => {
            return (_openBlock(), _createBlock(_component_PaymentMethodItem, {
              key: associatedPaymentMethod.billingPaymentMethodId,
              modelValue: _ctx.associatedPaymentMethodList[index],
              "onUpdate:modelValue": ($event: any) => ((_ctx.associatedPaymentMethodList[index]) = $event),
              "multi-method-id": _ctx.multiMethodId,
              onDeleteAssociatedPaymentMethod: ($event: any) => (_ctx.deleteAssociatedPaymentMethod(index))
            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "multi-method-id", "onDeleteAssociatedPaymentMethod"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
  ])), [
    [_directive_loading, _ctx.isAssociatedPaymentMethodListLoading]
  ])
}